import { render, staticRenderFns } from "./NoHeader.vue?vue&type=template&id=1b24bb06"
import script from "./NoHeader.vue?vue&type=script&lang=js"
export * from "./NoHeader.vue?vue&type=script&lang=js"
import style0 from "./NoHeader.vue?vue&type=style&index=0&id=1b24bb06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
